import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/link';

const NavItem = ({
  isFooterLink,
  itemClass,
  linkClass,
  label,
  url,
  children,
  onParentHover,
  onParentClick,
}) => (
  <li
    className={itemClass}
    onMouseEnter={onParentHover}
    onMouseLeave={onParentHover}
    aria-haspopup="true"
  >
    <Link
      isFooterLink={isFooterLink}
      to={url}
      className={linkClass}
      onClick={() => onParentClick()}
    >{label}</Link>
    {children}
  </li>
);

NavItem.propTypes = {
  isFooterLink: PropTypes.bool,
  itemClass: PropTypes.string,
  linkClass: PropTypes.string,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  children: PropTypes.node,
  onParentHover: PropTypes.func,
  onParentClick: PropTypes.func,
};

NavItem.defaultProps = {
  isFooterLink: false,
  itemClass: 'navItem',
  linkClass: 'navLink',
  children: false,
  onParentHover: () => {},
  onParentClick: () => {},
};

export default NavItem;
